import producer from 'immer';
import { FETCH_NOT_STARTED_PHOTO_SESSIONS, FETCH_STARTED_PHOTO_SESSIONS } from './types';
import { addNotStartedPhotoSessionsToState } from './handlers/notStartedHandlers';
import { addStartedPhotoSessionsToState } from './handlers/startedHandlers';

export const initialState = {
  notStarted: [],
  toReschedule: [],
  started: [],
  hasFetchedNotStartedPhotoSessions: false,
  hasFetchedStartedPhotoSessions: false,
  showNotStartedListError: false,
  showStartedListError: false,
};

export const photoSessionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOT_STARTED_PHOTO_SESSIONS:
      return addNotStartedPhotoSessionsToState(state, action);
    case FETCH_STARTED_PHOTO_SESSIONS:
      return addStartedPhotoSessionsToState(state, action);
    default:
      return state;
  }
};

export default producer(photoSessionsReducer);
